var map = {
	"./donaciones.jpg": "66fd",
	"./museo_tecnologia.jpg": "0ea8",
	"./slideshow_1.jpg": "5450",
	"./slideshow_2.jpg": "6f47",
	"./slideshow_3.jpg": "19cd",
	"./slideshow_4.jpg": "48a6",
	"./slideshow_5.jpg": "1aa8",
	"./slideshow_6.jpg": "e24c",
	"./slideshow_7.jpg": "deda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9fad";